(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-editorial"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.editorial-carousel').forEach(function (section) {
    var track   = section.querySelector('[data-carousel-track]');
    if (!track) return;

    var slides   = track.querySelectorAll('.editorial-carousel__slide');
    var current  = section.querySelector('[data-carousel-current]');
    var prev     = section.querySelector('[data-carousel-prev]');
    var next     = section.querySelector('[data-carousel-next]');
    var index    = 0;
    var total    = slides.length;

    if (total <= 1) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function goTo(i) {
      slides[index].classList.remove('is-active');
      index = (i + total) % total;
      slides[index].classList.add('is-active');
      if (current) current.textContent = pad(index + 1);
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    var startX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) goTo(dx < 0 ? index + 1 : index - 1);
    }, { passive: true });
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
